// Firmalar Mock Verileri
// Tedarikçiler, taşeronlar ve diğer firmalar

export const mockCompanies = [
    {
        id: 'comp-1',
        name: 'Demir Yapı İnşaat Ltd. Şti.',
        shortName: 'Demir Yapı',
        type: 'subcontractor', // subcontractor, supplier, service
        typeLabel: 'Taşeron',
        phone: '0212 555 1234',
        email: 'info@demiryapi.com',
        taxNo: '1234567890',
        taxOffice: 'Kadıköy Vergi Dairesi',
        address: 'Sanayi Mah. Fabrika Cad. No:45, Tuzla/İstanbul',
        website: 'www.demiryapi.com',
        contactPerson: 'Kemal Demir',
        contactPhone: '0532 111 2233',
        constructionId: 'const-1',
        // Detaylı Bilgiler
        specialty: 'Kaba İnşaat, Betonarme',
        notes: 'Yeşil Park projesinin kaba inşaat taşeronu. Güvenilir, zamanında teslim.',
        rating: 5, // 1-5
        // İş geçmişi
        contracts: [
            {
                id: 'contract-1',
                title: 'Yeşil Park - Kaba İnşaat',
                constructionName: 'Yeşil Park Konutları',
                startDate: '2025-03-01',
                endDate: '2025-06-30',
                totalAmount: 8500000,
                status: 'active',
            }
        ],
        // Ödeme geçmişi
        payments: [
            { id: 'pay-c1', date: '2025-04-15', amount: 1500000, type: 'hakedis', description: '1. hakediş' },
            { id: 'pay-c2', date: '2025-06-15', amount: 1500000, type: 'hakedis', description: '2. hakediş' },
            { id: 'pay-c3', date: '2025-08-15', amount: 1500000, type: 'hakedis', description: '3. hakediş' },
            { id: 'pay-c4', date: '2025-10-15', amount: 1500000, type: 'hakedis', description: '4. hakediş' },
            { id: 'pay-c5', date: '2025-01-15', amount: 1500000, type: 'hakedis', description: '5. hakediş' },
        ],
        totalPaid: 7500000,
        totalRemaining: 1000000,
        createdAt: '2025-02-15',
    },
    {
        id: 'comp-2',
        name: 'Öztürk Elektrik San. ve Tic. A.Ş.',
        shortName: 'Öztürk Elektrik',
        type: 'subcontractor',
        typeLabel: 'Taşeron',
        phone: '0216 444 5678',
        email: 'bilgi@ozturkelektrik.com',
        taxNo: '2345678901',
        taxOffice: 'Maltepe Vergi Dairesi',
        address: 'Organize San. Böl. 5. Cad. No:12, Gebze/Kocaeli',
        website: 'www.ozturkelektrik.com',
        contactPerson: 'Serkan Öztürk',
        contactPhone: '0533 222 3344',
        constructionId: 'const-1',
        specialty: 'Elektrik Tesisatı, Aydınlatma',
        notes: 'Her iki projede de elektrik işlerini üstleniyor.',
        rating: 4,
        contracts: [
            {
                id: 'contract-2',
                title: 'Yeşil Park - Elektrik Tesisatı',
                constructionName: 'Yeşil Park Konutları',
                startDate: '2025-08-01',
                endDate: '2025-08-31',
                totalAmount: 2200000,
                status: 'active',
            },
            {
                id: 'contract-3',
                title: 'Global - Elektrik Tesisatı',
                constructionName: 'Global Rezidans',
                startDate: '2025-01-01',
                endDate: '2026-03-31',
                totalAmount: 3500000,
                status: 'active',
            }
        ],
        payments: [
            { id: 'pay-c6', date: '2025-10-01', amount: 500000, type: 'hakedis', description: 'YP 1. hakediş' },
            { id: 'pay-c7', date: '2025-02-01', amount: 500000, type: 'hakedis', description: 'YP 2. hakediş' },
            { id: 'pay-c8', date: '2025-04-01', amount: 800000, type: 'hakedis', description: 'MD 1. hakediş' },
        ],
        totalPaid: 1800000,
        totalRemaining: 3900000,
        createdAt: '2025-07-20',
    },
    {
        id: 'comp-3',
        name: 'Çelik Tesisat ve Isıtma Sistemleri',
        shortName: 'Çelik Tesisat',
        type: 'subcontractor',
        typeLabel: 'Taşeron',
        phone: '0212 666 7890',
        email: 'info@celiktesisat.com',
        taxNo: '3456789012',
        taxOffice: 'Şişli Vergi Dairesi',
        address: 'Mecidiyeköy Mah. Tesisat Sok. No:8, Şişli/İstanbul',
        website: '',
        contactPerson: 'Ahmet Çelik',
        contactPhone: '0534 333 4455',
        constructionId: 'const-2',
        specialty: 'Su Tesisatı, Doğalgaz, Isıtma',
        notes: 'Global projesinin tesisat taşeronu.',
        rating: 5,
        contracts: [
            {
                id: 'contract-4',
                title: 'Global - Tesisat İşleri',
                constructionName: 'Global Rezidans',
                startDate: '2025-03-01',
                endDate: '2026-02-28',
                totalAmount: 4200000,
                status: 'active',
            }
        ],
        payments: [
            { id: 'pay-c9', date: '2025-05-01', amount: 1000000, type: 'hakedis', description: '1. hakediş' },
            { id: 'pay-c10', date: '2025-07-01', amount: 1000000, type: 'hakedis', description: '2. hakediş' },
        ],
        totalPaid: 2000000,
        totalRemaining: 2200000,
        createdAt: '2025-02-10',
    },
    {
        id: 'comp-4',
        name: 'Anadolu Beton San. A.Ş.',
        shortName: 'Anadolu Beton',
        type: 'supplier',
        typeLabel: 'Tedarikçi',
        phone: '0262 777 8901',
        email: 'satis@anadolubeton.com',
        taxNo: '4567890123',
        taxOffice: 'Gebze Vergi Dairesi',
        address: 'Dilovası OSB 3. Yol No:25, Dilovası/Kocaeli',
        website: 'www.anadolubeton.com',
        contactPerson: 'Fikret Yılmaz',
        contactPhone: '0535 444 5566',
        constructionId: null, // her iki projeye de
        specialty: 'Hazır Beton, Çimento',
        notes: 'Her iki proje için hazır beton tedarikçisi.',
        rating: 4,
        contracts: [
            {
                id: 'contract-5',
                title: 'Yeşil Park - Beton Tedariği',
                constructionName: 'Yeşil Park Konutları',
                startDate: '2025-03-01',
                endDate: '2025-06-30',
                totalAmount: 3200000,
                status: 'completed',
            },
            {
                id: 'contract-6',
                title: 'Global - Beton Tedariği',
                constructionName: 'Global Rezidans',
                startDate: '2025-01-01',
                endDate: '2026-06-30',
                totalAmount: 4800000,
                status: 'active',
            }
        ],
        payments: [
            { id: 'pay-c11', date: '2025-05-15', amount: 800000, type: 'fatura', description: 'YP 1. parti' },
            { id: 'pay-c12', date: '2025-08-15', amount: 800000, type: 'fatura', description: 'YP 2. parti' },
            { id: 'pay-c13', date: '2025-11-15', amount: 800000, type: 'fatura', description: 'YP 3. parti' },
            { id: 'pay-c14', date: '2025-02-15', amount: 800000, type: 'fatura', description: 'YP 4. parti + MD 1. parti' },
            { id: 'pay-c15', date: '2025-05-15', amount: 1200000, type: 'fatura', description: 'MD 2. parti' },
        ],
        totalPaid: 4400000,
        totalRemaining: 3600000,
        createdAt: '2025-02-01',
    },
    {
        id: 'comp-5',
        name: 'İstanbul Demir Çelik Tic. Ltd. Şti.',
        shortName: 'İstanbul Demir Çelik',
        type: 'supplier',
        typeLabel: 'Tedarikçi',
        phone: '0212 888 9012',
        email: 'siparis@istdemircelik.com',
        taxNo: '5678901234',
        taxOffice: 'Beyoğlu Vergi Dairesi',
        address: 'Kağıthane San. Sit. B Blok No:15, Kağıthane/İstanbul',
        website: 'www.istdemircelik.com',
        contactPerson: 'Murat Kara',
        contactPhone: '0536 555 6677',
        constructionId: null,
        specialty: 'İnşaat Demiri, Profil',
        notes: 'Ana demir tedarikçisi. Hızlı teslimat.',
        rating: 5,
        contracts: [
            {
                id: 'contract-7',
                title: 'Yeşil Park - Demir Tedariği',
                constructionName: 'Yeşil Park Konutları',
                startDate: '2025-03-01',
                endDate: '2025-04-30',
                totalAmount: 5500000,
                status: 'completed',
            }
        ],
        payments: [
            { id: 'pay-c16', date: '2025-04-01', amount: 1000000, type: 'fatura', description: '1. teslimat' },
            { id: 'pay-c17', date: '2025-07-01', amount: 1500000, type: 'fatura', description: '2. teslimat' },
            { id: 'pay-c18', date: '2025-10-01', amount: 1500000, type: 'fatura', description: '3. teslimat' },
            { id: 'pay-c19', date: '2025-01-01', amount: 1500000, type: 'fatura', description: '4. teslimat' },
        ],
        totalPaid: 5500000,
        totalRemaining: 0,
        createdAt: '2025-02-20',
    },
    {
        id: 'comp-6',
        name: 'Modern Asansör Sistemleri A.Ş.',
        shortName: 'Modern Asansör',
        type: 'subcontractor',
        typeLabel: 'Taşeron',
        phone: '0216 999 0123',
        email: 'info@modernasansor.com',
        taxNo: '6789012345',
        taxOffice: 'Ümraniye Vergi Dairesi',
        address: 'Dudullu OSB 7. Cad. No:33, Ümraniye/İstanbul',
        website: 'www.modernasansor.com',
        contactPerson: 'Erkan Aslan',
        contactPhone: '0537 666 7788',
        constructionId: null,
        specialty: 'Asansör Montajı, Bakım',
        notes: 'Her iki proje için asansör taşeronu.',
        rating: 4,
        contracts: [
            {
                id: 'contract-8',
                title: 'Yeşil Park - 4 Adet Asansör',
                constructionName: 'Yeşil Park Konutları',
                startDate: '2025-04-01',
                endDate: '2025-08-31',
                totalAmount: 1600000,
                status: 'active',
            },
            {
                id: 'contract-9',
                title: 'Global - 6 Adet Asansör',
                constructionName: 'Global Rezidans',
                startDate: '2026-01-01',
                endDate: '2026-05-31',
                totalAmount: 2400000,
                status: 'pending',
            }
        ],
        payments: [
            { id: 'pay-c20', date: '2025-05-01', amount: 400000, type: 'avans', description: 'YP avans' },
        ],
        totalPaid: 400000,
        totalRemaining: 3600000,
        createdAt: '2025-03-15',
    },
    {
        id: 'comp-7',
        name: 'Güvenlik ve Otomasyon Ltd. Şti.',
        shortName: 'Güvenlik Otomasyon',
        type: 'service',
        typeLabel: 'Hizmet',
        phone: '0212 111 2222',
        email: 'destek@guvenlikotomasyon.com',
        taxNo: '7890123456',
        taxOffice: 'Ataşehir Vergi Dairesi',
        address: 'Ataşehir Finans Merkezi B1 Blok, Ataşehir/İstanbul',
        website: 'www.guvenlikotomasyon.com',
        contactPerson: 'Selim Güven',
        contactPhone: '0538 777 8899',
        constructionId: 'const-2',
        specialty: 'Güvenlik Sistemleri, Akıllı Bina',
        notes: 'Global için akıllı bina ve güvenlik sistemleri.',
        rating: 5,
        contracts: [
            {
                id: 'contract-10',
                title: 'Global - Akıllı Bina Sistemleri',
                constructionName: 'Global Rezidans',
                startDate: '2025-10-01',
                endDate: '2026-04-30',
                totalAmount: 1800000,
                status: 'pending',
            }
        ],
        payments: [],
        totalPaid: 0,
        totalRemaining: 1800000,
        createdAt: '2025-08-01',
    },
    {
        id: 'comp-8',
        name: 'Yeşil Peyzaj ve Çevre Düzenleme',
        shortName: 'Yeşil Peyzaj',
        type: 'service',
        typeLabel: 'Hizmet',
        phone: '0216 333 4444',
        email: 'info@yesilpeyzaj.com',
        taxNo: '8901234567',
        taxOffice: 'Kartal Vergi Dairesi',
        address: 'Kartal Mah. Yeşil Sok. No:5, Kartal/İstanbul',
        website: 'www.yesilpeyzaj.com',
        contactPerson: 'Deniz Yeşil',
        contactPhone: '0539 888 9900',
        constructionId: 'const-1',
        specialty: 'Peyzaj, Bahçe Düzenleme',
        notes: 'Yeşil Park çevre düzenlemesi.',
        rating: 4,
        contracts: [
            {
                id: 'contract-11',
                title: 'Yeşil Park - Peyzaj',
                constructionName: 'Yeşil Park Konutları',
                startDate: '2025-07-01',
                endDate: '2025-10-31',
                totalAmount: 850000,
                status: 'active',
            }
        ],
        payments: [
            { id: 'pay-c21', date: '2025-07-15', amount: 200000, type: 'avans', description: 'Avans' },
        ],
        totalPaid: 200000,
        totalRemaining: 650000,
        createdAt: '2025-06-15',
    },
    {
        id: 'comp-9',
        name: 'Alüminyum Cam Sistemleri A.Ş.',
        shortName: 'Alüm-Cam',
        type: 'supplier',
        typeLabel: 'Tedarikçi',
        phone: '0212 444 5555',
        email: 'satis@alumcam.com',
        taxNo: '9012345678',
        taxOffice: 'Esenyurt Vergi Dairesi',
        address: 'Esenyurt San. Sit. D Blok No:42, Esenyurt/İstanbul',
        website: 'www.alumcam.com',
        contactPerson: 'Okan Cam',
        contactPhone: '0540 999 0011',
        constructionId: null,
        specialty: 'Alüminyum Doğrama, Cam',
        notes: 'Pencere ve kapı sistemleri tedarikçisi.',
        rating: 4,
        contracts: [
            {
                id: 'contract-12',
                title: 'Yeşil Park - Alüminyum Doğrama',
                constructionName: 'Yeşil Park Konutları',
                startDate: '2025-03-01',
                endDate: '2025-09-30',
                totalAmount: 2800000,
                status: 'active',
            }
        ],
        payments: [
            { id: 'pay-c22', date: '2025-04-01', amount: 700000, type: 'fatura', description: '1. parti' },
            { id: 'pay-c23', date: '2025-06-01', amount: 700000, type: 'fatura', description: '2. parti' },
        ],
        totalPaid: 1400000,
        totalRemaining: 1400000,
        createdAt: '2025-02-01',
    },
    {
        id: 'comp-10',
        name: 'Mimar Proje Danışmanlık',
        shortName: 'Mimar Proje',
        type: 'service',
        typeLabel: 'Hizmet',
        phone: '0212 555 6666',
        email: 'info@mimarproje.com',
        taxNo: '0123456789',
        taxOffice: 'Beşiktaş Vergi Dairesi',
        address: 'Levent Mah. İş Kuleleri A Blok Kat:12, Levent/İstanbul',
        website: 'www.mimarproje.com',
        contactPerson: 'Selin Mimar',
        contactPhone: '0541 000 1122',
        constructionId: null,
        specialty: 'Mimari Proje, Statik, Mühendislik',
        notes: 'Her iki projenin mimari ve mühendislik projeleri.',
        rating: 5,
        contracts: [
            {
                id: 'contract-13',
                title: 'Yeşil Park - Proje',
                constructionName: 'Yeşil Park Konutları',
                startDate: '2024-06-01',
                endDate: '2025-02-28',
                totalAmount: 1200000,
                status: 'completed',
            },
            {
                id: 'contract-14',
                title: 'Global - Proje',
                constructionName: 'Global Rezidans',
                startDate: '2025-03-01',
                endDate: '2025-12-31',
                totalAmount: 1800000,
                status: 'completed',
            }
        ],
        payments: [
            { id: 'pay-c24', date: '2024-08-01', amount: 600000, type: 'fatura', description: 'YP 1. ödeme' },
            { id: 'pay-c25', date: '2025-01-01', amount: 600000, type: 'fatura', description: 'YP 2. ödeme' },
            { id: 'pay-c26', date: '2025-05-01', amount: 900000, type: 'fatura', description: 'MD 1. ödeme' },
            { id: 'pay-c27', date: '2025-11-01', amount: 900000, type: 'fatura', description: 'MD 2. ödeme' },
        ],
        totalPaid: 3000000,
        totalRemaining: 0,
        createdAt: '2024-05-15',
    },
    {
        id: 'comp-101',
        name: 'Beto-san Beton A.Ş.',
        shortName: 'Beto-san Beton',
        type: 'supplier',
        typeLabel: 'Tedarikçi',
        phone: '0216 111 22 33',
        email: 'info@betosan.com',
        taxNo: '1012345678',
        taxOffice: 'Kartal VD',
        address: 'Kartal/İstanbul',
        website: 'betosan.com',
        contactPerson: 'Ali Veli',
        contactPhone: '0530 111 2233',
        constructionId: null,
        specialty: 'Hazır Beton',
        notes: 'Beton dökümü bedeli ödemeleri yapılıyor.',
        rating: 4,
        contracts: [],
        payments: [],
        totalPaid: 100000,
        totalRemaining: 50000,
        createdAt: '2025-01-10',
    },
    {
        id: 'comp-11',
        name: 'Kuzey Yapı Malzemeleri',
        shortName: 'Kuzey Yapı',
        type: 'supplier',
        typeLabel: 'Tedarikçi',
        phone: '0212 222 33 44',
        email: 'satis@kuzeyyapi.com',
        taxNo: '1112345678',
        taxOffice: 'Şişli VD',
        address: 'Şişli/İstanbul',
        website: 'kuzeyyapi.com',
        contactPerson: 'Bora Kuzey',
        contactPhone: '0531 222 3344',
        constructionId: null,
        specialty: 'Yapı Malzemesi',
        notes: '',
        rating: 4,
        contracts: [],
        payments: [],
        totalPaid: 0,
        totalRemaining: 0,
        createdAt: '2025-01-12',
    },
    {
        id: 'comp-102',
        name: 'Yıldız İnşaat ve Taşeronluk',
        shortName: 'Yıldız İnşaat',
        type: 'subcontractor',
        typeLabel: 'Taşeron',
        phone: '0216 333 44 55',
        email: 'iletisim@yildizinsaat.com',
        taxNo: '1022345678',
        taxOffice: 'Maltepe VD',
        address: 'Maltepe/İstanbul',
        website: '',
        contactPerson: 'Serdar Yıldız',
        contactPhone: '0532 333 4455',
        constructionId: 'const-1',
        specialty: 'Kaba İnşaat',
        notes: 'Taşeron hakedişi kesiliyor.',
        rating: 5,
        contracts: [],
        payments: [],
        totalPaid: 200000,
        totalRemaining: 150000,
        createdAt: '2025-01-15',
    },
    {
        id: 'comp-12',
        name: 'Doğu İklimlendirme A.Ş.',
        shortName: 'Doğu Klima',
        type: 'subcontractor',
        typeLabel: 'Taşeron',
        phone: '0212 444 55 66',
        email: 'info@doguklima.com',
        taxNo: '1212345678',
        taxOffice: 'Beşiktaş VD',
        address: 'Beşiktaş/İstanbul',
        website: '',
        contactPerson: 'Cem Doğu',
        contactPhone: '0533 444 5566',
        constructionId: null,
        specialty: 'HVAC',
        notes: '',
        rating: 4,
        contracts: [],
        payments: [],
        totalPaid: 0,
        totalRemaining: 0,
        createdAt: '2025-01-16',
    },
    {
        id: 'comp-103',
        name: 'Mermer Sanat Atölyesi',
        shortName: 'Mermer Sanat',
        type: 'subcontractor',
        typeLabel: 'Taşeron',
        phone: '0216 555 66 77',
        email: 'info@mermersanat.com',
        taxNo: '1032345678',
        taxOffice: 'Tuzla VD',
        address: 'Tuzla/İstanbul',
        website: 'mermersanat.com',
        contactPerson: 'Kemal Sanat',
        contactPhone: '0534 555 6677',
        constructionId: 'const-2',
        specialty: 'Mermer İşleri',
        notes: 'Mermer döşeme işlemleri tamamlandı.',
        rating: 4,
        contracts: [],
        payments: [],
        totalPaid: 50000,
        totalRemaining: 25000,
        createdAt: '2025-01-20',
    },
    {
        id: 'comp-13',
        name: 'Batı Seramik Ltd.',
        shortName: 'Batı Seramik',
        type: 'supplier',
        typeLabel: 'Tedarikçi',
        phone: '0212 666 77 88',
        email: 'satis@batiseramik.com',
        taxNo: '1312345678',
        taxOffice: 'Kagithane VD',
        address: 'Kağıthane/İstanbul',
        website: 'batiseramik.com',
        contactPerson: 'Deniz Batı',
        contactPhone: '0535 666 7788',
        constructionId: null,
        specialty: 'Seramik ve Fayans',
        notes: '',
        rating: 5,
        contracts: [],
        payments: [],
        totalPaid: 0,
        totalRemaining: 0,
        createdAt: '2025-01-22',
    },
    {
        id: 'comp-14',
        name: 'Güney Yalıtım Sistemleri',
        shortName: 'Güney Yalıtım',
        type: 'subcontractor',
        typeLabel: 'Taşeron',
        phone: '0216 777 88 99',
        email: 'iletisim@guneyyalitim.com',
        taxNo: '1412345678',
        taxOffice: 'Pendik VD',
        address: 'Pendik/İstanbul',
        website: '',
        contactPerson: 'Ahmet Güney',
        contactPhone: '0536 777 8899',
        constructionId: 'const-1',
        specialty: 'Isı Yalıtımı',
        notes: '',
        rating: 4,
        contracts: [],
        payments: [],
        totalPaid: 0,
        totalRemaining: 0,
        createdAt: '2025-01-25',
    },
    {
        id: 'comp-15',
        name: 'Ege Ahşap Dekorasyon',
        shortName: 'Ege Ahşap',
        type: 'supplier',
        typeLabel: 'Tedarikçi',
        phone: '0232 888 99 00',
        email: 'info@egeahsap.com',
        taxNo: '1512345678',
        taxOffice: 'Bornova VD',
        address: 'Bornova/İzmir',
        website: 'egeahsap.com',
        contactPerson: 'Mehmet Ege',
        contactPhone: '0537 888 9900',
        constructionId: null,
        specialty: 'Ahşap, Kapı, Dolap',
        notes: '',
        rating: 5,
        contracts: [],
        payments: [],
        totalPaid: 0,
        totalRemaining: 0,
        createdAt: '2025-01-28',
    },
    {
        id: 'comp-16',
        name: 'Asya İskele Kiralama',
        shortName: 'Asya İskele',
        type: 'service',
        typeLabel: 'Hizmet',
        phone: '0216 999 00 11',
        email: 'kiralama@asyaiskele.com',
        taxNo: '1612345678',
        taxOffice: 'Ümraniye VD',
        address: 'Ümraniye/İstanbul',
        website: '',
        contactPerson: 'Turan Asya',
        contactPhone: '0538 999 0011',
        constructionId: 'const-2',
        specialty: 'İskele Kiralama',
        notes: '',
        rating: 3,
        contracts: [],
        payments: [],
        totalPaid: 0,
        totalRemaining: 0,
        createdAt: '2025-02-01',
    },
    {
        id: 'comp-17',
        name: 'Mavi Cam Pazarlama',
        shortName: 'Mavi Cam',
        type: 'supplier',
        typeLabel: 'Tedarikçi',
        phone: '0212 101 20 30',
        email: 'satis@mavicam.com',
        taxNo: '1712345678',
        taxOffice: 'Zeytinburnu VD',
        address: 'Zeytinburnu/İstanbul',
        website: '',
        contactPerson: 'Ceren Mavi',
        contactPhone: '0539 101 2030',
        constructionId: null,
        specialty: 'Dış Cephe Cam',
        notes: '',
        rating: 4,
        contracts: [],
        payments: [],
        totalPaid: 0,
        totalRemaining: 0,
        createdAt: '2025-02-05',
    },
    {
        id: 'comp-18',
        name: 'Zirve Hafriyat T.C. A.Ş.',
        shortName: 'Zirve Hafriyat',
        type: 'service',
        typeLabel: 'Hizmet',
        phone: '0216 202 30 40',
        email: 'iletisim@zirvehafriyat.com',
        taxNo: '1812345678',
        taxOffice: 'Sancaktepe VD',
        address: 'Sancaktepe/İstanbul',
        website: '',
        contactPerson: 'Hakan Zirve',
        contactPhone: '0540 202 3040',
        constructionId: 'const-1',
        specialty: 'Hafriyat',
        notes: '',
        rating: 4,
        contracts: [],
        payments: [],
        totalPaid: 0,
        totalRemaining: 0,
        createdAt: '2025-02-08',
    },
    {
        id: 'comp-19',
        name: 'Net Bilişim ve Kamera',
        shortName: 'Net Güvenlik',
        type: 'service',
        typeLabel: 'Hizmet',
        phone: '0212 303 40 50',
        email: 'destek@netbilisim.com',
        taxNo: '1912345678',
        taxOffice: 'Maslak VD',
        address: 'Sarıyer/İstanbul',
        website: 'netbilisim.com',
        contactPerson: 'Okan Net',
        contactPhone: '0541 303 4050',
        constructionId: null,
        specialty: 'Kamera ve Bilişim',
        notes: '',
        rating: 5,
        contracts: [],
        payments: [],
        totalPaid: 0,
        totalRemaining: 0,
        createdAt: '2025-02-10',
    },
    {
        id: 'comp-20',
        name: 'Gürses Jeneratör Sistemleri',
        shortName: 'Gürses',
        type: 'supplier',
        typeLabel: 'Tedarikçi',
        phone: '0216 404 50 60',
        email: 'satis@gurses.com',
        taxNo: '2012345678',
        taxOffice: 'Çekmeköy VD',
        address: 'Çekmeköy/İstanbul',
        website: 'gurses.com',
        contactPerson: 'Murat Gürses',
        contactPhone: '0542 404 5060',
        constructionId: 'const-2',
        specialty: 'Jeneratör',
        notes: '',
        rating: 4,
        contracts: [],
        payments: [],
        totalPaid: 0,
        totalRemaining: 0,
        createdAt: '2025-02-12',
    },
    {
        id: 'comp-21',
        name: 'Parıltı Boya Sanayi',
        shortName: 'Parıltı Boya',
        type: 'supplier',
        typeLabel: 'Tedarikçi',
        phone: '0212 505 60 70',
        email: 'info@pariltiboya.com',
        taxNo: '2112345678',
        taxOffice: 'Avcılar VD',
        address: 'Avcılar/İstanbul',
        website: '',
        contactPerson: 'Ayşe Parıltı',
        contactPhone: '0543 505 6070',
        constructionId: null,
        specialty: 'Boya ve İzolasyon',
        notes: '',
        rating: 5,
        contracts: [],
        payments: [],
        totalPaid: 0,
        totalRemaining: 0,
        createdAt: '2025-02-15',
    },
    {
        id: 'comp-22',
        name: 'Sağlam Yapı Denetim A.Ş.',
        shortName: 'Sağlam Denetim',
        type: 'service',
        typeLabel: 'Hizmet',
        phone: '0216 606 70 80',
        email: 'denetim@saglamyapi.com',
        taxNo: '2212345678',
        taxOffice: 'Beykoz VD',
        address: 'Beykoz/İstanbul',
        website: 'saglamyapi.com',
        contactPerson: 'Kemal Sağlam',
        contactPhone: '0544 606 7080',
        constructionId: 'const-1',
        specialty: 'Yapı Denetim',
        notes: '',
        rating: 5,
        contracts: [],
        payments: [],
        totalPaid: 0,
        totalRemaining: 0,
        createdAt: '2025-02-18',
    }
];

// Helper functions
export const getCompanyById = (id) => mockCompanies.find(c => c.id === id);

export const getCompaniesByConstructionId = (constructionId) => {
    if (!constructionId) return mockCompanies;
    return mockCompanies.filter(c => !c.constructionId || c.constructionId === constructionId);
};

export const getSubcontractors = () => mockCompanies.filter(c => c.type === 'subcontractor');
export const getSuppliers = () => mockCompanies.filter(c => c.type === 'supplier');
export const getServiceProviders = () => mockCompanies.filter(c => c.type === 'service');

export const getCompanyStats = (constructionId) => {
    const companies = getCompaniesByConstructionId(constructionId);
    return {
        total: companies.length,
        subcontractors: companies.filter(c => c.type === 'subcontractor').length,
        suppliers: companies.filter(c => c.type === 'supplier').length,
        services: companies.filter(c => c.type === 'service').length,
        totalPaid: companies.reduce((sum, c) => sum + (c.totalPaid || 0), 0),
        totalRemaining: companies.reduce((sum, c) => sum + (c.totalRemaining || 0), 0),
    };
};

// Mock'a yeni firma ekler — gerçek uygulamada fn_upsert_company_account() RPC çağrılır
export const addMockCompany = (companyData) => {
    const exists = mockCompanies.find(
        c => c.name.toLowerCase() === companyData.name.toLowerCase()
    );
    if (exists) return exists;
    mockCompanies.push(companyData);
    return companyData;
};

export default mockCompanies;
